
import $store from 'stores/global'
export default {
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close () {
      this.$refs.modal.close()
    },
    async submit() {
      this.close()
      $store.deleteOnboarding()
    }
  }
}
